export default {
  apiKey: "AIzaSyBECcLmhYgXNYCuf-hkYlPhuXwjmVl3XBQ",
  authDomain: "tuh-transform.firebaseapp.com",
  projectId: "tuh-transform",
  storageBucket: "tuh-transform.appspot.com",
  messagingSenderId: "242189043316",
  appId: "1:242189043316:web:7c185ad278f93b86843321",
  measurementId: "G-70NX3D7NQ4"
};